export const SAVE_FOOD_PREFERENCES_REQUEST = 'SAVE_FOOD_PREFERENCES_REQUEST';
export const SAVE_FOOD_PREFERENCES_SUCCESS = 'SAVE_FOOD_PREFERENCES_SUCCESS';
export const SAVE_FOOD_PREFERENCES_FAILED = 'SAVE_FOOD_PREFERENCES_FAILED';

export const SAVE_DIET_GOAL_REQUEST = 'SAVE_DIET_GOAL_REQUEST';
export const SAVE_DIET_GOAL_SUCCESS = 'SAVE_DIET_GOAL_SUCCESS';
export const SAVE_DIET_GOAL_FAILED = 'SAVE_DIET_GOAL_FAILED';

export const GET_MEAL_PLAN_REQUEST = 'GET_MEAL_PLAN_REQUEST';
export const GET_MEAL_PLAN_SUCCESS = 'GET_MEAL_PLAN_SUCCESS';
export const GET_MEAL_PLAN_FAILED = 'GET_MEAL_PLAN_FAILED';

export const GET_SHOPPING_LIST_REQUEST = 'GET_SHOPPING_LIST_REQUEST';
export const GET_SHOPPING_LIST_SUCCESS = 'GET_SHOPPING_LIST_SUCCESS';
export const GET_SHOPPING_LIST_FAILED = 'GET_SHOPPING_LIST_FAILED';

export const GET_MEALS_FOR_TIME_OF_DAY_REQUEST = 'GET_MEALS_FOR_TIME_OF_DAY_REQUEST';
export const GET_MEALS_FOR_TIME_OF_DAY_SUCCESS = 'GET_MEALS_FOR_TIME_OF_DAY_SUCCESS';
export const GET_MEALS_FOR_TIME_OF_DAY_FAILED = 'GET_MEALS_FOR_TIME_OF_DAY_FAILED';
export const CLEAR_MEALS_FOR_TIME_OF_DAY = 'CLEAR_MEALS_FOR_TIME_OF_DAY';

export const GET_THUMBNAILS_REQUEST = 'GET_THUMBNAILS_REQUEST';
export const SET_THUMBNAILS = 'SET_THUMBNAILS';
export const SET_IMAGE = 'SET_IMAGE';

export const SET_USER_MEAL_PLAN_REQUEST = 'SET_USER_MEAL_PLAN_REQUEST';
export const SET_USER_MEAL_PLAN_SUCCESS = 'nutrition_recipe_detail_meal_change';
export const SET_USER_MEAL_PLAN_FAILED = 'SET_USER_MEAL_PLAN_FAILED';

export const SET_NUTRITION_PREFERENCE = 'SET_NUTRITION_PREFERENCE';

export const SET_SHOPPING_LIST_SETTINGS_REQUEST = 'SET_SHOPPING_LIST_SETTINGS_REQUEST';
export const SET_SHOPPING_LIST_SETTINGS_FAILED = 'SET_SHOPPING_LIST_SETTINGS_FAILED';
export const SET_SHOPPING_LIST_SETTINGS_SUCCESS = 'SET_SHOPPING_LIST_SETTINGS_SUCCESS';

export const SET_CHECKLIST_EXCLUSIONS_REQUEST = 'SET_CHECKLIST_EXCLUSIONS_REQUEST';
export const SET_CHECKLIST_EXCLUSIONS_FAILED = 'SET_CHECKLIST_EXCLUSIONS_FAILED';
export const SET_CHECKLIST_EXCLUSIONS_SUCCESS = 'SET_CHECKLIST_EXCLUSIONS_SUCCESS';

export const SET_TAB_INDEX = 'SET_TAB_INDEX';

export const SET_NUTRITION_RATING_REQUEST = 'SET_NUTRITION_RATING_REQUEST';
export const SET_NUTRITION_RATING_FAILED = 'SET_NUTRITION_RATING_FAILED';
export const SET_NUTRITION_RATING_SUCCESS = 'nutrition_rate';

export const GET_NUTRITION_RATING_DATA = 'GET_NUTRITION_RATING_DATA';
export const GET_NUTRITION_RATING_DATA_FAILED = 'GET_NUTRITION_RATING_DATA_FAILED';
export const TOGGLE_NUTRITION_REVIEW_BODY = 'TOGGLE_NUTRITION_REVIEW_BODY';

export const CHANGE_NUTRITION_DAY = 'nutrition_recipe_list_date_change';
export const MEAL_DETAILED_TAB_SELECT = 'nutrition_recipe_detail_tab_select';
export const OPEN_NUTRITION_STEP_VIDEO = 'nutrition_learn_video_open';
export const UNCHECK_ALL_SHOPPING_LIST_ITEMS  = 'nutrition_shoppinglist_uncheckall';
export const TOGGLE_SHOPPING_LIST_ITEM_CHECK_STATUS = 'TOGGLE_SHOPPING_LIST_ITEM_CHECK_STATUS';
export const ORDER_MEALS_OPEN = 'nutrition_ordermeals_order_open';
export const NUTRITION_PREFERENCE_CHANGE = 'nutrition_learn_foodpreference_change';
export const NUTRITION_TAB_SELECTED = 'nutrition_tab_selected';

export const MEAL_ROW_PRESSED = 'MEAL_ROW_PRESSED';
export const TOGGLE_MEAL_MODAL = 'ui/modal/mealModal';

export const TOGGLE_MEAL_SELECTION_WIZARD_SCREEN = 'TOGGLE_MEAL_SELECTION_WIZARD_SCREEN';

export const MAXIMUM_MEAL_PREP_TIME_CHANGED = 'MAXIMUM_MEAL_PREP_TIME_CHANGED';
export const SET_UNIT_PREFERENCE = 'SET_UNIT_PREFERENCE';
